import beastMastery from './beast-mastery'
import marksmanship from './marksmanship'
import survival from './survival'

const hunter = { specs: [beastMastery, marksmanship, survival] }

export default hunter
